var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_heart",
    "data-name": "vuesax/bold/heart",
    transform: "translate(-236 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.44,0A5.549,5.549,0,0,0,10,2.23,5.552,5.552,0,0,0,0,5.59,10.678,10.678,0,0,0,.52,8.9c1.58,5,6.45,7.99,8.86,8.81a2.181,2.181,0,0,0,1.24,0c2.41-.82,7.28-3.81,8.86-8.81A10.678,10.678,0,0,0,20,5.59,5.574,5.574,0,0,0,14.44,0Z",
    transform: "translate(238 191.1)",
    fill: "#1383D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(260 212) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFill);
export default __webpack_public_path__ + "static/media/heart-fill.5ac1babf2a5165926cb3a5c56e8dd0ed.svg";
export { ForwardRef as ReactComponent };